import { useState } from 'react';
import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/news';

const tabs = [
  { key: 'all', label: '全部推荐' },
  { key: 'variety', label: '综艺热度' },
  { key: 'drama', label: '剧集观察' },
  { key: 'music', label: '音乐舞台' },
  { key: 'meme', label: '网络热梗' },
];

export default function RecommendGrid() {
  const [active, setActive] = useState('all');

  const list = active === 'all' ? articles.slice(0, 6) : articles.filter((a) => a.category === active);

  return (
    <section id="recommend" className="bg-background-200 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.25em] text-primary-600">EDITOR'S PICK</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">编辑推荐话题</h2>
            <p className="mt-2 text-sm text-foreground-600">信息密度高、观点清晰的话题，适合优先阅读。</p>
          </div>

          <div className="flex flex-wrap gap-1 rounded-full border border-background-300 bg-background-50 p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
                  active === tab.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        ) : (
          <div className="mt-8 rounded-lg border border-dashed border-background-400 bg-background-50 py-16 text-center">
            <i className="ri-inbox-archive-line text-3xl text-foreground-400" aria-hidden="true"></i>
            <p className="mt-3 text-sm text-foreground-600">该分类下暂无推荐话题，换个分类看看吧。</p>
          </div>
        )}

        <div className="mt-8 flex justify-center">
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            前往话题合集
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}